/* ============
 * Actions for the account module
 * ============
 *
 * The actions that are available on the
 * account module.
 */

import * as types from './mutation-types'

import {   comprehensivePrivacyNotice,
  policyWhatsappBusiness,
  confidentialityDataProcessingLetter, } from '@/services/user/'

export const loadSaved = ({ commit }) => {
  const data = localStorage.getItem('accessToken')
  if (data) {
    commit(types.STORE, { email: data })
  }
}

export const store = ({ commit }, payload) => {
  commit(types.STORE, payload)
}

export const update = ({ commit }, payload) => {
  commit(types.UPDATE, payload)
}

export const check = ({ commit, state }) => {
  commit(types.CHECK)
}

export const load = ({ commit, state }) => {
  commit(types.STORE, state.accountLoaded)
  // commit(types.UNLOAD)
}

export const submitComprehensivePrivacyNotice = async({ commit }) => {
  try {
    comprehensivePrivacyNotice()
      .then(() => (commit(types.SET_COMPREHENSIVE_PRIVACY_NOTICE)))
  } catch (error) {
    console.log(error)
  }
}

export const submitConfidentialityDataProcessingLetter = async({ commit }) => {
  try {
    confidentialityDataProcessingLetter()
      .then(() => (commit(types.SET_CONFIDENTIALITY_DATA_PROCESSING_LETTER)))
  } catch (error) {
    console.log(error)
  }
}

export const submitPolicyWhatsappBusiness = async({ commit }) => {
  try {
    policyWhatsappBusiness()
      .then(() => (commit(types.SET_POLICY_WHATSAPP_BUSINESS)))
  } catch (error) {
    console.log(error)
  }
}

export default {
  store,
  update,
  loadSaved,
  check,
  load,
  submitComprehensivePrivacyNotice,
  submitConfidentialityDataProcessingLetter,
  submitPolicyWhatsappBusiness
}
